export default __webpack_public_path__ + "static/ios-case-3-17813309522278a6594981fa0dd34166.webp";